import React from 'react';
import { MdDelete, MdModeEdit } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { deleteSubSection } from '../../../../services/operations/courseApi';

const UpdateSubSection = ({ subSection, sectionId, setConfirmationModal }) => {
    const dispatch = useDispatch();
    const editSubSectionHandler = () => {
    }
    const deleteSubSectionHandler = (subSectionID) => {
        try {
            dispatch(deleteSubSection(sectionId, subSectionID, dispatch));
        } catch (error) {
            console.log('error while deleting sub-section -> ', error)
        }
    }

    return (
        <div className='flex items-center gap-x-2'>
            <button
                type='button'
                onClick={() => editSubSectionHandler(subSection)}
            >
                <MdModeEdit />
            </button>
            <button
                type='button'
                onClick={() => setConfirmationModal(
                    {
                        text1: 'Delete Sub-Section Confirmation',
                        text2: 'Are You Sure You Want to Delete This Sub-Section?',
                        closeModal: () => setConfirmationModal(null),
                        btn1Text: 'Delete',
                        btn2Text: 'Cancel',
                        btn1Handler: () => deleteSubSectionHandler(subSection._id),
                        btn2Handler: () => setConfirmationModal(null),
                    }
                )}
            >
                <MdDelete />
            </button>
        </div>
    )
}

export default UpdateSubSection;